export const FIRST_AVAILABLE_YEAR = 1985

export const COMPANY_ENTRY_YEAR_START = 1985

export function buildYearRange (endYear = new Date().getFullYear(), startYear = FIRST_AVAILABLE_YEAR) {
  const years = []
  for (let year = endYear; year >= startYear; year--) {
    years.push(year)
  }
  return years
}

export function yearsInRange (startYear, endYear) {
  const years = []
  for (let year = startYear; year <= endYear; year++) {
    years.push(year)
  }
  return years
}



// WEBPACK FOOTER //
// ./src/constants/report_period.js